<template>
    <div style="display: contents">
        <v-dialog
            :value="true"
            hide-overlay
            transition="none"
            eager
            content-class="access-password-dialog"
            max-width="800px"
            persistent
            no-click-animation
        >
            <v-overlay
                absolute
                class="acccess-password-overlay"
                color="#071441E5"
                opacity="0.5"
                z-index="1"
                :value="dialog"
            />
            <v-card style="z-index: 2;">
                <v-card-title>
                    Enter Password to Access
                </v-card-title>
                <v-card-subtitle>
                    Please enter the password to get access
                </v-card-subtitle>
                <v-card-text>
                    <div class="access-password-label">
                        Password
                    </div>
                    <v-text-field
                        v-model="password"
                        type="password"
                        outlined
                        hide-details="auto"
                        :error="!!errorMessage"
                        :error-messages="errorMessage"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded x-large @click="validatePassword">Submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "FormSubmitAccessPassword",
        props: {
            accessPassword: {
                type: String,
                required: true,
            },
        },
        components: {
            ExternalLinkIcon: () => import('vue-feather-icons/icons/ExternalLinkIcon'),
            XIcon: () => import('vue-feather-icons/icons/XIcon'),
            FormslyFormWrapper: () => import('@/components/FormGenericComponents/FormslyFormWrapper')
        },
        data: () => ({
            dialog: true,
            password: '',
            errorMessage: '',
        }),
        methods: {
            validatePassword() {
                if (this.password === this.accessPassword) {
                    this.$emit('validate-password', true);
                    this.errorMessage = ''; 
                } else {
                    this.errorMessage = 'Invalid password. Please try again.';
                }
            },
        }
    }
</script>

<style lang="scss">
    .acccess-password-dialog {
        box-shadow: none !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        border-radius: 0 !important;
    }

    .access-password-label {
        font-size: .875rem;
        line-height: 1.25rem;
        font-weight: 500;
        color: var(--v-dark_gray-base);
        margin-bottom: 8px;
        margin-top: 12px;
    }

    .acccess-password-overlay {
        height: 100vh;
        transition: .2s;
        backdrop-filter: blur(10px) opacity(0);

        .v-overlay__scrim {
            backdrop-filter: blur(10px) opacity(0);
            border-radius: 0;
        }

        &.v-overlay--active {
            backdrop-filter: blur(10px) opacity(1);

            .v-overlay__scrim {
                backdrop-filter: blur(10px) opacity(1);

            }
        }
    }
</style>